/*
 * Copyright (c) 2021 LNBIG.com
 * All rights reserved.
 */

/*
* This code from here: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
* */

export default function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
